import { render, staticRenderFns } from "./resourceLib.vue?vue&type=template&id=a03e2170&scoped=true&"
import script from "./resourceLib.vue?vue&type=script&lang=js&"
export * from "./resourceLib.vue?vue&type=script&lang=js&"
import style0 from "./resourceLib.vue?vue&type=style&index=0&id=a03e2170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03e2170",
  null
  
)

export default component.exports